import type { Vehicle } from './domain/model';
export const time = (n: number) =>
  new Date(n).toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
export const eta = (v: Vehicle, now: number) => {
  if (!v.journey) return '—';
  if (v.journey.routeStatus === 'error') return 'Route fehlt';
  if (v.journey.routeStatus !== 'ready') return 'Route lädt …';
  const seconds = Math.ceil(Math.max(0, v.journey.end - now) / 1000);
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
};
